module.exports = __webpack_public_path__ + "img/canpro_logicflow.aa1a2e6b.svg";